import { render, staticRenderFns } from "./endereco.vue?vue&type=template&id=4c3d3ac6&scoped=true&"
import script from "./endereco.vue?vue&type=script&lang=js&"
export * from "./endereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3d3ac6",
  null
  
)

export default component.exports